// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

// Formatting and presentation utilities for MRQ table components

// SRP helpers
// Special header formatting map
const specialHeaders: Record<
  string,
  Record<string, string | ((h: string) => string)>
> = {
  '10k': { heliter: 'He[l]' },
  '4k': {
    heliter: 'He[l]',
    he1: 'He1[%]',
    he2: 'He2[%]',
    phap: (h: string) => h.toUpperCase(),
  },
};

export const isDrycool = (type: string): boolean => type === 'drycool';
export const isCapitalizeType = (type: string): boolean =>
  ['10k', '4k'].includes(type);
export const formatDrycoolHeader = (header: string): string => header.toUpperCase();
export const formatCapitalizeTypeHeader = (header: string): string =>
  capitalizeShortWords(header);
export const formatNumber = (value: number, locale: string = 'en'): string => {
  return new Intl.NumberFormat(locale).format(value);
};

export const capitalizeHeader = (
  header: string,
  magnetType: string,
): string => {
  const type = magnetType.toLowerCase();
  if (header.length === 0) return header;

  const headerKey = header.toLowerCase();
  const typeHeaders = specialHeaders[type];

  if (typeHeaders?.[headerKey]) {
    const value = typeHeaders[headerKey];
    return typeof value === 'function' ? value(header) : value;
  }

  if (isDrycool(type)) return formatDrycoolHeader(header);
  if (isCapitalizeType(type)) return formatCapitalizeTypeHeader(header);
  return header;
};

export const capitalizeShortWords = (text: string): string => {
  return text
    .split(' ')
    .map((word) => allCapsIfShort(word))
    .join(' ');
};

export const allCapsIfShort = (word: string): string => {
  if (word.length < 4) {
    return word.toUpperCase();
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
};
